import "./Image.scss";

import React, { FunctionComponent, useEffect, useState } from "react";

import { Dialog, DialogAlignment } from "@itwin/core-react";
import { ModelessDialogManager } from "@itwin/appui-react";
import { IconButton } from "@itwin/itwinui-react";

import { cMessage } from "./Message";
import { cZoom } from "./Image";

const imageUpdateEvent = "image.update";
const DLG_WIDTH = 800;
const DLG_HEIGHT = 500;

const ImageDlg: FunctionComponent<{ image: string }> = ({ image }) => {
  const [dlgImage, setDlgImage] = useState("");

  useEffect(() => {
    cMessage.setupUiEvent(imageUpdateEvent, getNewImage);
    setDlgImage(image);

    const _divHTML = document.getElementById("zoomDIV")!;
    if (_divHTML) {
      // add listeners for mouse actions
      _divHTML.addEventListener("mousemove", cZoom.mouseMove);
      _divHTML.addEventListener("mousedown", cZoom.mouseDown);
      _divHTML.addEventListener("mouseup", cZoom.mouseUp);
    }

    return () => {
      cMessage.removeUiEvent(imageUpdateEvent);

      const _divHTML = document.getElementById("zoomDIV")!;
      if (_divHTML) {
        // remove listeners added for mouse actions
        _divHTML.removeEventListener("mousemove", cZoom.mouseMove);
        _divHTML.removeEventListener("mousedown", cZoom.mouseDown);
        _divHTML.removeEventListener("mouseup", cZoom.mouseUp);
      }
    };
  }, []);

  useEffect(() => {
    const img = document.getElementById("imageDIV") as HTMLImageElement;
    if (img) {
      img.onload = function () {
        cZoom.initImage(
          dlgImage,
          img.width,
          (img.width * img.naturalHeight) / img.naturalWidth
        );
      };
    }
  }, [dlgImage]);

  const handleDialogClose = () => {
    cImageDlg.closeDialog();
  };

  const getNewImage = async () => {
    setDlgImage(cImageDlg.getImage());
  };

  const onZoomOut = async () => {
    //    if (cZoom.getZoomFactor() > 1.0) {
    cZoom.setZoomFactor(cZoom.getZoomFactor() - 1.0);
    cZoom.zoomIn();
    //    }
  };

  const onZoomIn = async () => {
    //    if (cZoom.getZoomFactor() < MAX_ZOOM_FAC) {
    cZoom.setZoomFactor(cZoom.getZoomFactor() + 1.0);
    cZoom.zoomIn();
    //    }
  };

  const onZoomFactor = async (event: React.ChangeEvent<HTMLInputElement>) => {
    cZoom.setZoomFactor(Number(event.target.value));
    cZoom.zoomIn();
  };

  return (
    <Dialog
      id={"imageDialog"}
      opened={true}
      modal={false}
      onClose={handleDialogClose}
      onEscape={handleDialogClose}
      resizable={false}
      movable={true}
      inset={true}
      hideHeader={false}
      title={
        <div>
          <span className="icon icon-camera"></span> <span>Image</span>
        </div>
      }
      width={DLG_WIDTH + 20}
      height={DLG_HEIGHT + 20}
      alignment={DialogAlignment.Center}
    >
      <div className="img-zoom-container">
        <div id="zoomDIV" className="img-zoom-result" hidden={false}>
          {/*style={{ backgroundImage: `url(${imageUrl})`}}> */}
        </div>
        <img
          id="imageDIV"
          src={dlgImage}
          width={DLG_WIDTH}
          height={DLG_HEIGHT}
          hidden={true}
        />
      </div>
      <hr />

      <div className="img-center">
        <IconButton styleType="borderless" size="large" onClick={onZoomOut}>
          <span
            className="icon icon-zoom-out"
            title={"Zoom Out"}
            style={{ color: "dodgerblue" }}
          ></span>
        </IconButton>
        <input
          type="range"
          id="zoomFactor"
          min={1}
          max={10}
          defaultValue={1}
          step={0.25}
          onChange={onZoomFactor}
        ></input>
        <IconButton styleType="borderless" size="large" onClick={onZoomIn}>
          <span
            className="icon icon-zoom-in"
            title={"Zoom In"}
            style={{ color: "dodgerblue" }}
          ></span>
        </IconButton>
      </div>
    </Dialog>
  );
};

export class cImageDlg {
  private static _image: string;
  private static _id: string = "imageDialog";

  public static openDialog = (image: string) => {
    this.setImage(image);
    ModelessDialogManager.openDialog(cImageDlg.imageDialog(image), this._id);
  };

  private static imageDialog = (image: string): React.ReactNode => {
    return <ImageDlg image={image} />;
  }

  public static updateDialog = (image: string) => {
    this.setImage(image);
    cMessage.raiseUiEvent(imageUpdateEvent);
  }

  public static closeDialog = () => {
    ModelessDialogManager.closeDialog(this._id);
  }

  public static isDialogOpen = (): boolean => {
    if (ModelessDialogManager.getDialogInfo(this._id)) {
      return true;
    }
    return false;
  }

  public static setImage = (image: string) => {
    this._image = image;
  }

  public static getImage = (): string => {
    return this._image!;
  }
}